import { CSSProperties } from "react";
import { Form } from "antd";
import { rgba, cssVar } from "polished";
import styled from "styled-components";
import theme from "styles/theme";

const fontFamilyDefault = "@font-family";
const primaryColor = "@primary-color-brand";

const colorsHelper = () => {
  const defaultValue = "#fff";
  return {
    "--color-brand-100": cssVar("--color-brand-100", defaultValue),
    "--color-neutral-200": cssVar("--color-neutral-200", defaultValue),
    "--opacity-level-3": cssVar("--opacity-level-3", defaultValue),
    "--opacity-level-1": cssVar("--opacity-level-1", defaultValue),
  };
};

const { Item } = Form;

export const ReportContainer = styled.div`
  display: grid;
  align-items: center;
  grid-template-rows: 1fr 1fr;
  column-gap: 15px;
  .ant-select-single.ant-select-lg:not(.ant-select-customize-input) .ant-select-selector {
    border: 1px solid ${(props) => props.theme.colors.manatee};
    .ant-select-selection-placeholder {
      color: ${(props) => props.theme.colors.text};
    }
  }
  .ant-tooltip-disabled-compatible-wrapper {
    width: 100%;
  }
  .ant-input-affix-wrapper {
    > input {
      font-size: ${(props) => props.theme["@medium-font-size"]};
      font-weight: ${(props) => props.theme["@normal-font-weight"]};
    }
  }

  .ant-select-selector {
    height: ${(props) => props.theme["@height-input-lg"]} !important;
    border: 1.6px solid ${(props) => props.theme["@input-border-color"]};
    &:hover {
      border: 1.6px solid ${(props) => props.theme["@primary-color-brand"]} !important;
      background-color: ${() => rgba(colorsHelper()["--color-brand-100"], Number(colorsHelper()["--opacity-level-3"]))} !important;
    }
  }
  .ant-select:not(.ant-select-customize-input) .ant-select-selector:hover {
    border: 1.6px solid ${(props) => props.theme["@primary-color-brand"]} !important;
    background-color: ${() => rgba(colorsHelper()["--color-brand-100"], Number(colorsHelper()["--opacity-level-3"]))} !important;
  }
  .ant-select.ant-select-in-form-item.ant-select-focused {
    > div {
      border: 1.6px solid ${(props) => props.theme["@primary-color-brand"]} !important;
    }
  }
  .ant-select-multiple .ant-select-selection-item {
    border-radius: 17px !important;
    border: 1.6px solid ${(props) => props.theme["@input-border-color"]} !important;
    background-color: ${(props) => props.theme["@secondary-color"]} !important;
    :hover {
      background-color: ${(props) => props.theme["@hover-input-background-color"]} !important;
      border: 1.6px solid ${(props) => props.theme["@hover-input-background-color"]} !important;
    }
  }
`;

export const SelectStructureContainer = styled.div`
  align-items: center;
  .ant-select:not(.ant-select-customize-input) .ant-select-selector {
    border: 1.6px solid ${(props) => props.theme["@input-border-color"]} !important;
    &:hover,
    &:focus {
      border-color: ${(props) => props.theme[primaryColor]};
    }
  }
  .ant-select-disabled.ant-select:not(.ant-select-customize-input) .ant-select-selector {
    background-color: ${() => rgba(colorsHelper()["--color-neutral-200"], Number(colorsHelper()["--opacity-level-1"]))} !important;
    color: ${(props) => props.theme.colors.text} !important;
    :hover {
      background-color: ${() => rgba(colorsHelper()["--color-neutral-200"], Number(colorsHelper()["--opacity-level-1"]))} !important;
      border: 1.6px solid ${(props) => props.theme["@input-border-color"]} !important;
    }
  }
`;

export const ButtonSubmitFilterContainer = styled.div`
  align-items: center;
  display: flex;
  .primaryButton {
    height: ${(props) => props.theme["@height-button-lg"]};
    width: 100%;
    margin-top: 7px;
    box-shadow: none;
    color: ${(props) => props.theme["@default-color"]};
    font-size: ${(props) => props.theme["@large-font-size"]};
    font-weight: ${(props) => props.theme["@bold-font-weight"]};
    border: 1.6px ${(props) => props.theme["@hover-input-background-color"]} !important;
    background-color: ${(props) => props.theme["@primary-color-brand"]};
    -webkit-box-shadow: none !important;
    box-shadow: none !important;
    outline: none !important;
    -webkit-animation: none !important;
    animation: none !important;
    :hover {
      color: ${(props) => props.theme["@default-color"]};
      background-color: ${(props) => props.theme["@hover-input-background-color"]};
      border: none;
    }
    :focus {
      border: 1.6px ${(props) => props.theme["@hover-input-background-color"]} !important;
    }
  }
  .primaryButton[disabled] {
    background-color: ${(props) => props.theme["@muted-background"]} !important;
    border: 1.6px solid ${(props) => props.theme["@muted-background"]} !important;
    color: ${(props) => props.theme["@disabled-button"]} !important;
  }
  & [ant-click-animating-without-extra-node]:after {
    animation: 0s !important;
    border: 1.6px ${(props) => props.theme["@muted-background"]} !important;
  }
`;

export const ButtonSubmitExportContainer = styled.div`
  align-items: center;
  display: flex;
  > button > span > svg {
    margin-top: 4px;
  }
  .svg {
    align-items: center;
  }
  .secondaryButton {
    width: 100%;
    height: ${(props) => props.theme["@height-button-lg"]};
    color: ${(props) => props.theme.colors.text};
    font-size: ${(props) => props.theme["@large-font-size"]};
    font-weight: ${(props) => props.theme["@bold-font-weight"]};
    border: 1.6px solid ${(props) => props.theme.colors.text} !important;
    margin-top: 7px;
    display: flex;
    align-items: center;
    justify-content: center;
    :hover {
      background-color: ${(props) => props.theme["@hover-input-background-color"]} !important;
      border: 1.6px solid ${(props) => props.theme["@hover-input-background-color"]} !important;
      color: ${(props) => props.theme.colors.text};
    }
  }
  & [ant-click-animating-without-extra-node]:after {
    animation: 0s !important;
  }

  .secondaryButton[disabled] {
    background-color: ${(props) => props.theme["@muted-background"]} !important;
    border: 1.6px solid ${(props) => props.theme["@muted-background"]} !important;
    color: ${(props) => props.theme["@disabled-button"]} !important;
  }
`;

export const FilterContainerPrimary = styled.div`
  display: grid;
  align-items: center;
  grid-template-columns: 20% auto 30%;
  column-gap: 15px;
`;

export const FilterReportContainerSecondary = styled.div`
  display: grid;
  align-items: center;
  grid-template-columns: 12% 12% auto 10% 10%;
  column-gap: 15px;
  margin-top: -15px;

  @media (max-width: 1200px) {
    grid-template-columns: 1fr 1fr 2fr;
    grid-template-rows: auto auto;
    grid-auto-flow: row;

    & > :nth-child(1) {
      grid-column: 1;
      grid-row: 1;
    }
    & > :nth-child(2) {
      grid-column: 2;
      grid-row: 1;
    }
    & > :nth-child(3) {
      grid-column: 3;
      grid-row: 1;
    }
    & > :nth-child(4) {
      grid-column: 1 / span 2;
      grid-row: 2;
    }
    & > :nth-child(5) {
      grid-column: 3;
      grid-row: 2;
    }
  }
`;

export const FilterPlateContainer = styled.div`
  align-items: center;
  .inputUpper {
    input {
      text-transform: uppercase;
    }
  }
`;

export const LocationsContainer = styled.div`
  width: 100%;
  .ant-select-multiple .ant-select-selector {
    width: 100%;
    color: ${(props) => props.theme.colors.text};
    font-family: ${(props) => props.theme[fontFamilyDefault]};
    height: 40px;
    padding: 0 11px;
    border: 1.6px solid ${(props) => props.theme["@input-border-color"]} !important;
  }
  .ant-select-multiple.ant-select-disabled.ant-select:not(.ant-select-customize-input) .ant-select-selector {
    background-color: ${() => rgba(colorsHelper()["--color-neutral-200"], Number(colorsHelper()["--opacity-level-1"]))} !important;
    color: ${(props) => props.theme.text} !important;
    :hover {
      background-color: ${() => rgba(colorsHelper()["--color-neutral-200"], Number(colorsHelper()["--opacity-level-1"]))} !important;
      border: 1.6px solid ${(props) => props.theme["@input-border-color"]} !important;
    }
  }
  .ant-select-disabled.ant-select-multiple .ant-select-selection-item {
    color: ${(props) => props.theme.colors.text} !important;
    background-color: #ebebeb !important;
    border: 1.6px solid ${(props) => props.theme["@input-border-color"]} !important;
    :hover {
      background-color: #ebebeb !important;
      border: 1.6px solid ${(props) => props.theme["@input-border-color"]} !important;
    }
  }
`;

export const DatePickerContainer = styled.div`
  align-items: center;
  width: 100%;
`;

export const FilterDocumentContainer = styled.div`
  align-items: center;
`;

export const FilterCarrierContainer = styled.div`
  align-items: center;
`;

export const ReportTitle: CSSProperties = {
  fontWeight: "lighter",
  fontFamily: theme[fontFamilyDefault],
};

export const StructureSelect: CSSProperties = {
  color: theme.colors["@text"],
  fontFamily: theme[fontFamilyDefault],
  fontSize: theme["@medium-font-size"],
  height: theme["@height-button-lg"],
};

export const LocationSelect: CSSProperties = {
  width: "100%",
  color: theme.colors["@text"],
  fontFamily: theme[fontFamilyDefault],
  fontSize: theme["@medium-font-size"],
  height: theme["@height-button-lg"],
};

export const SpaceDatePicker: CSSProperties = {
  width: "100%",
};

export const InputFields: CSSProperties = {
  width: "100%",
  color: theme.colors["@text"],
  fontFamily: theme[fontFamilyDefault],
  fontSize: theme["@medium-font-size"],
  height: theme["@height-button-lg"],
};

export const FormItem = styled(Item)`
  .ant-select:not(.ant-select-customize-input) .ant-select-selector {
    border: 1.6px solid ${(props) => props.theme["@input-border-color"]} !important;
    &:hover,
    &:focus {
      border-color: ${(props) => props.theme[primaryColor]} !important;
    }
  }
`;

export const FakeBtnConfirm: CSSProperties = {
  display: "none",
};
